export enum CentralIaTypes {
  SEND_CHAT_MESSAGE_REQUEST = '@central_ia/SEND_CHAT_MESSAGE_REQUEST',
  CHAT_STREAM_START = '@central_ia/CHAT_STREAM_START',
  CHAT_STREAM_CHUNK = '@central_ia/CHAT_STREAM_CHUNK',
  CHAT_STREAM_DONE = '@central_ia/CHAT_STREAM_DONE',
  CHAT_STREAM_TITLE = '@central_ia/CHAT_STREAM_TITLE',
  CHAT_STREAM_ERROR = '@central_ia/CHAT_STREAM_ERROR',
  CHAT_STREAM_STOPPED = '@central_ia/CHAT_STREAM_STOPPED',
  CHAT_FILES_MISSING = '@central_ia/CHAT_FILES_MISSING',
  GENERATE_IMAGE_REQUEST = '@central_ia/GENERATE_IMAGE_REQUEST',
  GENERATE_IMAGE_SUCCESS = '@central_ia/GENERATE_IMAGE_SUCCESS',
  GENERATE_IMAGE_FAILURE = '@central_ia/GENERATE_IMAGE_FAILURE',
  CREATE_FOLDER_REQUEST = '@central_ia/CREATE_FOLDER_REQUEST',
  CREATE_FOLDER_SUCCESS = '@central_ia/CREATE_FOLDER_SUCCESS',
  CREATE_FOLDER_FAILURE = '@central_ia/CREATE_FOLDER_FAILURE',
  RESET_CREATE_FOLDER = '@central_ia/RESET_CREATE_FOLDER',
  FETCH_FOLDERS_REQUEST = '@central_ia/FETCH_FOLDERS_REQUEST',
  FETCH_FOLDERS_SUCCESS = '@central_ia/FETCH_FOLDERS_SUCCESS',
  FETCH_FOLDERS_FAILURE = '@central_ia/FETCH_FOLDERS_FAILURE',
  DELETE_FOLDER_REQUEST = '@central_ia/DELETE_FOLDER_REQUEST',
  DELETE_FOLDER_SUCCESS = '@central_ia/DELETE_FOLDER_SUCCESS',
  DELETE_FOLDER_FAILURE = '@central_ia/DELETE_FOLDER_FAILURE',
  UPDATE_FOLDER_REQUEST = '@central_ia/UPDATE_FOLDER_REQUEST',
  UPDATE_FOLDER_SUCCESS = '@central_ia/UPDATE_FOLDER_SUCCESS',
  UPDATE_FOLDER_FAILURE = '@central_ia/UPDATE_FOLDER_FAILURE',
  FETCH_CHATS_REQUEST = '@central_ia/FETCH_CHATS_REQUEST',
  FETCH_CHATS_SUCCESS = '@central_ia/FETCH_CHATS_SUCCESS',
  FETCH_CHATS_FAILURE = '@central_ia/FETCH_CHATS_FAILURE',
  DELETE_CHAT_REQUEST = '@central_ia/DELETE_CHAT_REQUEST',
  DELETE_CHAT_SUCCESS = '@central_ia/DELETE_CHAT_SUCCESS',
  DELETE_CHAT_FAILURE = '@central_ia/DELETE_CHAT_FAILURE',
  FETCH_CHAT_REQUEST = '@central_ia/FETCH_CHAT_REQUEST',
  FETCH_CHAT_SUCCESS = '@central_ia/FETCH_CHAT_SUCCESS',
  FETCH_CHAT_FAILURE = '@central_ia/FETCH_CHAT_FAILURE',
  UPDATE_CHAT_REQUEST = '@central_ia/UPDATE_CHAT_REQUEST',
  UPDATE_CHAT_SUCCESS = '@central_ia/UPDATE_CHAT_SUCCESS',
  UPDATE_CHAT_FAILURE = '@central_ia/UPDATE_CHAT_FAILURE',
  MOVE_CHAT_REQUEST = '@central_ia/MOVE_CHAT_REQUEST',
  MOVE_CHAT_SUCCESS = '@central_ia/MOVE_CHAT_SUCCESS',
  MOVE_CHAT_FAILURE = '@central_ia/MOVE_CHAT_FAILURE',
  UPLOAD_FILE_REQUEST = '@central_ia/UPLOAD_FILE_REQUEST',
  UPLOAD_FILE_SUCCESS = '@central_ia/UPLOAD_FILE_SUCCESS',
  UPLOAD_FILE_FAILURE = '@central_ia/UPLOAD_FILE_FAILURE',
  REMOVE_PENDING_FILE = '@central_ia/REMOVE_PENDING_FILE',
  CLEAR_PENDING_FILES = '@central_ia/CLEAR_PENDING_FILES',
  REMOVE_CHAT_FILE = '@central_ia/REMOVE_CHAT_FILE',
  ADD_USER_MESSAGE = '@central_ia/ADD_USER_MESSAGE',
  SET_PROVIDER = '@central_ia/SET_PROVIDER',
  SET_MODEL = '@central_ia/SET_MODEL',
  START_CHAT = '@central_ia/START_CHAT',
  NEW_CHAT = '@central_ia/NEW_CHAT',
  TOGGLE_SIDEBAR = '@central_ia/TOGGLE_SIDEBAR',
  CLEAR_CHAT = '@central_ia/CLEAR_CHAT',
}

export interface CentralIaCitation {
  url: string;
  title?: string | null;
}

export interface CentralIaMessage {
  id: number;
  role: 'user' | 'assistant';
  content: string;
  requestId?: string;
  imageUrl?: string;
  citations?: CentralIaCitation[];
  streaming?: boolean;
  interrupted?: boolean;
}

export interface CentralIaFolder {
  id: number | string;
  name: string;
  created_at?: string;
}

export interface CentralIaFile {
  file_id: string | number;
  file_name: string;
  content_type?: string;
  size_bytes?: number;
  s3_url?: string;
}

export interface CentralIaChat {
  id: number;
  title: string;
  central_ia_folder_id: number | null;
  conversation_id: string;
  provider: string;
  model: string;
  last_message_at: string;
  created_at: string;
  updated_at: string;
}

export interface BaseRequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface RequestState {
  send_chat_message: BaseRequestState;
  generate_image: BaseRequestState;
  create_folder: BaseRequestState;
  fetch_folders: BaseRequestState;
  delete_folder: BaseRequestState;
  update_folder: BaseRequestState;
  fetch_chats: BaseRequestState;
  delete_chat: BaseRequestState;
  fetch_chat: BaseRequestState;
  update_chat: BaseRequestState;
  move_chat: BaseRequestState;
  upload_file: BaseRequestState;
}

export interface CentralIaState {
  messages: CentralIaMessage[];
  folders: CentralIaFolder[];
  chats: CentralIaChat[];
  pendingFiles: CentralIaFile[];
  chatFiles: CentralIaFile[];
  currentChatId: number | null;
  selectedProvider: string;
  selectedModel: string;
  chatStarted: boolean;
  sidebarCollapsed: boolean;
  conversationId: string | null;
  lastError?: string | null;
  readonly request: RequestState;
}
